import React, { useState } from 'react'
import { TargetCheckbox } from 'src/components/Global/CheckBox/Checkbox'
import { Wrapper, Container, BaseList, Description, Amount } from '../style'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/root-reducer'
import { addNairaSign } from 'src/utils/addNairaSign'
import NoPlan from 'src/components/GeneralSavings/WebTransaction/EmptyPlan/NoPlan'
import { TransactionWrapper } from '../headingStyle'
import { TransactionInfoWrapper } from '../listStyle'
interface ListProps {
  name: any
  balance: any
  accrued_interest: any
  start_date: any
  progress_percent: any
  id: any
}
const Completed = () => {
  const myPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans?.plans
  )

  const myTargetPlans = myPlans?.filter((el: any) => {
    return el.plan_type === 'target' && el.progress_percent >= 100
  })

  console.log(myTargetPlans)
  const handleChange = (e: any) => {
    console.log('clcicked')
  }
  const [id, setId] = useState()
  let location = useLocation()
  return (
    <TransactionInfoWrapper>
      <Container>
        {myTargetPlans?.length === 0 && (
          <NoPlan children="You have no targets. Create Target Now!!!" />
        )}
        {myTargetPlans?.length > 0 && (
          <div>
            <TransactionWrapper>
              <div className="transactionHeading ">
                <div className="type">
                  <p className="title">Description</p>
                </div>
                <div className="amount">
                  <p className="title">Amount</p>
                </div>
                <div className="date">
                  <p className="title">Date</p>
                </div>
                <div className="description">
                  <p className="title">Interest</p>
                </div>
              </div>
              {myTargetPlans?.map((item: ListProps) => {
                return (
                  <Link
                    to={`/target-detail/${item.id}`}
                    key={item.id}
                    state={{ backgroundLocation: location }}
                  >
                    <div
                      className="transactionHeadings "
                      key={item.id}
                      onClick={(e) => {
                        setId(id)
                      }}
                    >
                      <div className="typelist">
                        <p>{item.name}</p>
                      </div>
                      <div className="amountlist">
                        <p>{addNairaSign(item.balance)}</p>
                      </div>
                      <div className="datelist">
                        <p>{item.start_date}</p>
                      </div>
                      <div className="descriptionlist">
                        <p className="transactionDesc">
                          {addNairaSign(item.accrued_interest)}
                        </p>
                      </div>
                    </div>
                  </Link>
                )
              })}
            </TransactionWrapper>
          </div>
        )}
      </Container>
    </TransactionInfoWrapper>
  )
}
export { Completed }
